export var RankLabel;
(function (RankLabel) {
    RankLabel["Gold"] = "gold";
    RankLabel["Silver"] = "silver";
    RankLabel["Bronze"] = "bronze";
    RankLabel["Other"] = "other";
})(RankLabel || (RankLabel = {}));
